import type { Language } from '@yleisradio/areena-types';
import Script from 'next/script';
import React from 'react';
import { apmRum } from 'services/apm-rum';
import { init } from 'services/braze';
import logger from 'services/logger';
import { brazeSdkProperties } from 'services/properties/frontend';
import type { BrazeContentCard, BrazeSdk } from './types';

// Global braze is only used for the SDK initialization, otherwise it's used through the context
declare const braze: BrazeSdk | undefined;

type BrazeScriptLoaderProps = {
  language: Language;
  refreshToken: () => void;
  setContentCards: (contentCards: BrazeContentCard[]) => void;
  token: string;
  userId: string;
  onInit: (braze: BrazeSdk) => void;
};

export const BrazeScriptLoader: React.FC<BrazeScriptLoaderProps> = ({
  language,
  refreshToken,
  setContentCards,
  token,
  userId,
  onInit,
}) => {
  return (
    <Script
      src={brazeSdkProperties.url}
      strategy="lazyOnload"
      onLoad={() => {
        const initBraze = async () => {
          if (typeof braze === 'undefined') {
            throw new Error('Braze SDK global not defined');
          }
          await init({
            braze,
            language,
            refreshToken,
            setContentCards,
            token,
            userId,
          });
          onInit(braze);
        };

        initBraze().catch((error: unknown) => {
          logger.error(error, 'Failed to initialize Braze SDK');
          if (error instanceof Error) apmRum?.captureError(error);
        });
      }}
    />
  );
};
